// Argus's identity, once: the MCP server announces it (tools.ts) and build.mjs writes it into the
// generated manifest. Bump `version` when tools change, so an installed copy is offered the update.
export const APP = {
  id: "com.resatech.talkie.argus",
  name: "Argus",
  version: "2.6.2",
  description:
    "Watch six security cameras, review AI-flagged alerts, and rewind or snapshot the footage. Ask Dobby to share a snapshot in a channel or follow up in another app.",
  origin: "https://argus.touchtalkie.com",
} as const;

/** What the app asks Talkie for: nothing. Its page connects only to its own origin (`connect_domains`
 * is empty, and the vhost serves `connect-src 'self'`). */
export const REQUESTED_CAPABILITIES = { connect_domains: [] as string[] };
